module.exports = __webpack_public_path__ + "img/video-thumb.55c9e24c.png";